<template>
    <div class="container-back">
        <div class="back-div">
            <div class="wrap" @click="goBack()">
              <img src="../assets/back.png" alt="" srcset="" class="back">
              <span>返回</span>
            </div>
            <div class="wrap home" @click="goHome()">
              <span>退出</span>
            </div>
        </div>
      </div>
</template>
<script>
    export default {
        name:'pageBack',
        data() {
            return {
              
            }
        },
        methods: {
            goBack() {
                this.$router.back();
            }  ,
            goHome(){
                this.$router.push('/');
            }
        },
        // 例如这个函数就会在组件挂载完成后被调用
        mounted() {
              
        }
    }
</script>
<style src="" scoped lang="less">
    /* 你的 CSS 代码 */
    .container-back{
        position: fixed;
        top: 2.8rem;
        left: 0;
        z-index: 10000;
        width: 100%;
        height: 1.34rem;
    }
    .back-div{
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
    }
    .wrap{
        width: 2.44rem;
        height: 1.38rem;
        position: relative;
        background: url(../assets/back_bg.png) no-repeat;
        background-size: 2.44rem 1.38rem;
        padding-left: .32rem;
        display: flex;
        align-items: center;
        &.home{
            background: url(../assets/home_bg.png) no-repeat;
            background-size: 2.44rem 1.38rem;
            display: inline-flex;
            justify-content: center;
            padding-right: .25rem;
            padding-bottom: .1rem;
        }
        span{
            color: transparent;
            /* 文字颜色设为透明，使其不可见 */
            background: linear-gradient(90deg, #FFFFFF 0%, #DEFCFF 100%);
            -webkit-background-clip: text;
            /* 仅WebKit浏览器支持 */
            background-clip: text;
            /* 标准属性，现代浏览器支持 */
            text-shadow: 0 0.04rem 0.04rem rgba(0, 0, 0, 0.25);
            font-size: .4rem;
            font-weight: bold;
            margin-left: .29rem;
        }
    }
    img.back {
        width: .23rem;
        height: .4rem;
        // position: absolute;
        // left: -1.92rem;
        // top: 0;
    }
</style>